<div class="duna-event-price-extra-options-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Price-extras (katalog)</h1></mat-card-title>
      <mat-card-subtitle>
        Administrér organisationens price-extras til kursuspriser. De knyttes til prisskabeloner og vises på events med antal.
        API: <code>/events/price-extra-options</code>.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  @if (errorMessage) {
    <mat-card class="message-card message-card--error">
      <mat-card-content>
        <p class="error-message">{{ errorMessage }}</p>
      </mat-card-content>
    </mat-card>
  }

  <mat-card class="search-card">
    <mat-card-content>
      <div class="search-row">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Ny price-extra</mat-label>
          <input
            matInput
            [(ngModel)]="newLabel"
            (keyup.enter)="createOption()"
            placeholder="Fx materialer, transport…"
            [disabled]="creating || loading">
          <mat-icon matSuffix>add_circle_outline</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class="search-field price-field">
          <mat-label>Standardpris (kr.)</mat-label>
          <input matInput type="number" [(ngModel)]="newPrice" min="0" step="0.01" [disabled]="creating || loading">
        </mat-form-field>
        <button mat-raised-button color="primary" type="button" (click)="createOption()" [disabled]="creating || loading">
          {{ creating ? 'Opretter…' : 'Tilføj' }}
        </button>
        <button mat-stroked-button type="button" (click)="load()" [disabled]="loading || creating">
          <mat-icon>refresh</mat-icon>
          {{ loading ? 'Henter…' : 'Opdater' }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="table-card">
    <mat-card-header>
      <mat-card-title>Price-extras i kataloget</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (loading) {
        <div class="state">Henter katalog…</div>
      } @else {
        <table mat-table [dataSource]="tableDataSource" class="links-table">
          <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef>Navn</th>
            <td mat-cell *matCellDef="let row">
              <div class="label-edit-row">
                <mat-form-field appearance="outline" class="inline-label-field" subscriptSizing="dynamic">
                  <input matInput [(ngModel)]="labelDraft[row.id]" [disabled]="savingLabelId === row.id">
                </mat-form-field>
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="saveLabel(row)"
                  [disabled]="savingLabelId === row.id || !labelDirty(row)">
                  <mat-icon>save</mat-icon>
                  {{ savingLabelId === row.id ? 'Gemmer…' : 'Gem navn' }}
                </button>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="default_price">
            <th mat-header-cell *matHeaderCellDef>Standardpris (kr.)</th>
            <td mat-cell *matCellDef="let row">
              <div class="label-edit-row">
                <mat-form-field appearance="outline" class="inline-price-field" subscriptSizing="dynamic">
                  <input matInput type="number" [(ngModel)]="priceDraft[row.id]" min="0" step="0.01" [disabled]="savingPriceId === row.id">
                </mat-form-field>
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="savePrice(row)"
                  [disabled]="savingPriceId === row.id || !priceDirty(row)">
                  <mat-icon>save</mat-icon>
                  {{ savingPriceId === row.id ? 'Gemmer…' : 'Gem pris' }}
                </button>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef>Aktiv</th>
            <td mat-cell *matCellDef="let row">
              <mat-slide-toggle
                [checked]="row.is_active"
                [disabled]="togglingId === row.id"
                (change)="onActiveChange(row, $event)">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button
                mat-stroked-button
                color="warn"
                class="delete-btn"
                type="button"
                (click)="deleteOption(row)"
                [disabled]="deletingId === row.id">
                <mat-icon>{{ deletingId === row.id ? 'hourglass_top' : 'delete' }}</mat-icon>
                {{ deletingId === row.id ? 'Sletter…' : 'Slet' }}
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">Ingen price-extras i kataloget endnu.</td>
          </tr>
        </table>
      }
    </mat-card-content>
  </mat-card>
</div>
